module.exports = __webpack_public_path__ + "img/appIcon11.442ed029.png";